import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { NAME, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {
		ProvozovnaId: [],
		StrnakltypOzn: [],
	},
	filter: {
		ProvozovnaId: null as number | null,
		StrnakltypOzn: null as string | null,
		VyrazenPrp: null as boolean | null,
		StrednaklOzn: null as number | null,
	},
	tableSetting: {},
	rowDetail: null,
	localState: {
		disabledProvozovna: null as boolean | null, // TODO: - nepouziva sa treba zistit preco alebo zmazat
	},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {},
		mode: null,
		afterRowSelection: () => {},
	},
});
